module.exports = __webpack_public_path__ + "static/img/001.42a12da.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/001.png
// module id = jMvD
// module chunks = 1